// @ts-nocheck
const CONTAINER_SELECTORS = [
  '.fwrd-reviews__slide-video',
  '.fwrd-hiw__video-container',
  '.fwrd-what-and-how__media--video',
];

const ICON_MUTED = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true">
  <path d="M11 5L6 9H3v6h3l5 4V5z" fill="currentColor"/>
  <path d="M15.54 8.46a5 5 0 010 7.07M19.07 4.93a9 9 0 010 14.14" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
  <path d="M2 2l20 20" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
</svg>`;

const ICON_UNMUTED = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true">
  <path d="M11 5L6 9H3v6h3l5 4V5z" fill="currentColor"/>
  <path d="M15.54 8.46a5 5 0 010 7.07M19.07 4.93a9 9 0 010 14.14" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
</svg>`;

function getLabels(container) {
  const section =
    container.closest('section') ||
    container.closest('.fwrd-reviews__section');

  return {
    mute: section?.dataset.muteLabel || 'Mute video',
    unmute: section?.dataset.unmuteLabel || 'Unmute video',
  };
}

function updateButtonState(button, video, labels) {
  const isMuted = video.muted;

  button.setAttribute('aria-label', isMuted ? labels.unmute : labels.mute);
  button.setAttribute('aria-pressed', isMuted ? 'true' : 'false');
  button.classList.toggle('is-muted', isMuted);
  button.innerHTML = isMuted ? ICON_MUTED : ICON_UNMUTED;
}

function createMuteButton(video, container) {
  if (container.querySelector('.fwrd-video-mute-btn')) return;

  const labels = getLabels(container);
  const button = document.createElement('button');

  button.type = 'button';
  button.className = 'fwrd-video-mute-btn';

  button.addEventListener('click', (event) => {
    event.preventDefault();
    event.stopPropagation();
    video.muted = !video.muted;
    updateButtonState(button, video, labels);
  });

  video.addEventListener('volumechange', () => {
    updateButtonState(button, video, labels);
  });

  updateButtonState(button, video, labels);
  container.appendChild(button);
}

function initMuteButtons(root = document) {
  CONTAINER_SELECTORS.forEach((selector) => {
    root.querySelectorAll(selector).forEach((container) => {
      const video = container.querySelector('video');
      if (video) createMuteButton(video, container);
    });
  });
}

document.addEventListener('DOMContentLoaded', () => initMuteButtons());

document.addEventListener('shopify:section:load', (event) => {
  if (event.target instanceof HTMLElement) initMuteButtons(event.target);
});
